import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';

export class AffinityLightningTrait extends Trait {
  static baseType = TraitType.AffinityLightning;
  static baseTitle = 'Elemental Affinity (Lightning)';
  static baseText = 'Immune to Spark and Shocked.';
  static baseIcon = 'trait';

  type = AffinityLightningTrait.baseType;
  title = AffinityLightningTrait.baseTitle;
  text = AffinityLightningTrait.baseText;
  icon = AffinityLightningTrait.baseIcon;

  modifierAdd(type: StatusEffect, stacks: number) {
    if (type == StatusEffect.Spark || type == StatusEffect.Shocked) {
      return 0;
    }
    return stacks;
  }
}

TraitRegistry.register(AffinityLightningTrait.baseType, AffinityLightningTrait);
